export enum UnifyTrackingEvent {
  SIGN_OUT = 'sign-out',
  LEARN_MORE_DRAWER_OPEN = 'learn-more-drawer-open',
  LEARN_MORE_DRAWER_CLOSE = 'learn-more-drawer-close',
  DEVICE_OBSERVATION_DRAWER_OPEN = 'open-device-observation-details-drawer',
  DEVICE_OBSERVATION_DRAWER_CLOSE = 'close-device-observation-details-drawer',
  DATA_CHANGE_DRAWER_OPEN = 'open-data-change-drawer',
  DATA_CHANGE_DRAWER_CLOSE = 'close-data-change-drawer',
}
